import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { AuthService } from './auth.service';

@Injectable()
export class EmailDetailService {

  constructor(private http: HttpClient,
    private authService: AuthService) { }

  /**
   * Check for at least one email processed - for null state
   */
  atLeastOne(source: string): Observable<any> {
    var s = '';
    if (this.authService.isContributor) {
      s = source;
    }

    return this.http
      .get(
        `/api/v1/email_detail?source=${s}`
      );
  }

  getCount(filter): Observable<any> {
    return this.http
      .post(
        `/api/v1/email_detail/count`,
        JSON.stringify(filter)
      );
  }

  getPaginated(options): Observable<any> {
    return this.http
      .post(
        `/api/v1/email_detail/paginate`,
        JSON.stringify(options)
      );
  }

  getExport(filter): Observable<any> {
    return this.http
      .post(
        `/api/v1/email_detail/export`,
        JSON.stringify(filter),
        { responseType: 'text' } // need to specify so httpclient doesn't try to .json() this
      );
  }

  getFullEmail(emailDetailId): Observable<any> {
    return this.http
      .get(
        `/api/v1/email_detail/full/${emailDetailId}`
      );
  }

  reportQA(model): Observable<any> {
    return this.http
      .post(
        `/api/v1/email_detail/report`,
        JSON.stringify(model)
      );
  }

  hide(emailDetailId, accountId): Observable<any> {
    return this.http
      .post(
        `/api/v1/email_detail/hide`,
        JSON.stringify({ed_id: emailDetailId, account_id: accountId})
      );
  }

  changeType(emailDetailId: string, model: any): Observable<any> {
    return this.http
      .post(
        `/api/v1/email_detail/type/${emailDetailId}`,
        JSON.stringify(model)
      );
  }

  rerun(emailDetailId): Observable<any> {
    return this.http
      .get(
        `/api/v1/email_detail/rerun/${emailDetailId}`
      );
  }

  /**
   * Change approve status from draft to customer for a single email
   * @param emailDetailId
   */
  customerQueue(emailDetailId): Observable<any> {
    return this.http
    .post(
      `/api/v1/email_detail/customer`,
      JSON.stringify({ed_id : emailDetailId})
    );
  }

  /**
   * Change approve status to draft for all email details linked to account
   * @param accountId
   */
  toggleReviewQueueOff(accountId): Observable<any> {
    return this.http
    .post(
      `/api/v1/email_detail/toggleoff`,
      JSON.stringify({account_id : accountId})
    );
  }

  getCampaignDetails(campaignId): Observable<any> {
    return this.http
    .get(
      `/api/v1/email_campaign/${campaignId}/with_reply_bot`
    );
  }

  forward(edId:string, note:string, recipients:string[]): Observable<any> {
    return this.http
    .post(
      `/api/v1/email_detail/fwd`,
      JSON.stringify({edId, note:note || '', recipients})
    );
  }
}



// WEBPACK FOOTER //
// ./client/app/services/email-detail.service.ts